export interface PricedItem {
  price: number;
}

export function getCheapestItem<T extends PricedItem>(items: readonly T[]): T | null {
  return items.reduce<T | null>((cheapest, candidate) => {
    if (!isPositive(candidate.price)) return cheapest;

    return cheapest === null || candidate.price < cheapest.price ? candidate : cheapest;
  }, null);
}

export function getMinPositivePrice(items: readonly PricedItem[]): number | null {
  return getCheapestItem(items)?.price ?? null;
}

function isPositive(value: number | undefined): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}
